import Main from './BannerMain'
import Configuration from './BannerConfiguration'

export default {
  Main,
  Configuration,
}
